import React, { useMemo, createContext, useContext, useEffect } from 'react';
import io from 'socket.io-client';
import store from '../store';
import {
  addMessageUnansweredConversation,
  addUnAnsweredConversation,
  removeUnAnsweredConversation
} from '../store/action/unanswered-convertations-action';
import {
  removeAnsweredConversation,
  addMessageAnsweredConversation,
  addAnsweredConversation
} from '../store/action/answered-conversations-action';
import {
  addMessageConversationInAttendance,
  checkRemoveConversationInAttendance,
  deleteMessageConversationInAttendance,
  updateStatusMessageConversationInAttendance,
  updateWhatsappMessageIdConversationInAttendance
} from '../store/action/conversation-in-attendance-action';
import { useChat } from './useChat';
import { getDailyClosedChat } from '../store/action/update-chat-metrics-action';

const useSocketConversationChatTsContext = createContext();

export const EVENTS_EMIT = {
  CHAT_TRANSFER_BOT_TO_ATTENDANCE:
    'conversa_transferida_pelo_bot_para_atendente',
  TRANSFER_CHAT_TO_QUEUE: 'transferir_conversa',
  TRANSFER_MULTIPLE_CHAT_TO_QUEUE: 'transferir_multiplas_conversas',
  CUSTOMER_SENDING_MESSAGE: 'cliente_enviou_mensagem',
  DELETE_MESSAGE_FROM_CHAT: 'delete_message_from_chat',
  AMD_SENDING_WHISPER: 'adm_enviou_sussurro',
  CHAT_TRANSFERRED: 'conversa_transferida',
  CHAT_FINISHED: 'conversa_encerrada',
  DELETE_CHAT_FROM_QUEUE: 'remove_conversa_fila',
  SHOW_POPUP_TO_AGENT: 'show_popup_to_agent',
  ATTENDANT_FINISH_CHAT: 'encerra_conversa_atendente',
  FINISH_MULTIPLE_CONVERSATION: 'encerrar_multiplas_conversas',
  EVENT_OF_MESSAGE: 'evento_de_mensagem',
  CHANGE_MESSAGE_WHATSAPP_ID: 'change_message_whatsapp_id',

  ADD_CHAT_ON_HOLD: 'ADD_CHAT_ON_HOLD',
  REMOVE_CHAT_ON_HOLD: 'REMOVE_CHAT_ON_HOLD',
  ADD_CHAT_IN_AGENT: 'ADD_CHAT_IN_AGENT',
  REMOVE_CHAT_FROM_AGENT: 'REMOVE_CHAT_FROM_AGENT',
  ANSWERED_CHAT: 'atender_conversa',
  UPDATE_CONFIG_SIGNAL_CONVERSATION: 'UPDATE_CONFIG_SIGNAL_CONVERSATION',
  UPDATE_METRICS_OF_SERVICE_PANEL: 'UPDATE_METRICS_OF_SERVICE_PANEL'
};

export function ConversationChatTsConnectionSocketForMonitoringProvider({
  children
}) {
  const { removeChatSavedById } = useChat();
  const socketChatTS = useMemo(
    () =>
      io(process.env.REACT_APP_PROXY_URL, {
        path: '/flex-chat-integration-socket',
        transports: ['websocket'],
        upgrade: false,
        query: { token: localStorage.getItem('token') }
      }),
    []
  );

  useEffect(() => {
    return () => {
      socketChatTS.disconnect();
    };
  }, [socketChatTS]);

  useEffect(() => {
    socketChatTS.on(EVENTS_EMIT.ADD_CHAT_ON_HOLD, async (chat) => {
      await store.dispatch(addUnAnsweredConversation(chat));
      await store.dispatch(removeAnsweredConversation(chat?.id || chat?._id));
      await store.dispatch(
        checkRemoveConversationInAttendance(chat?.id || chat?._id)
      );
    });
  }, [socketChatTS]);

  useEffect(() => {
    socketChatTS.on(EVENTS_EMIT.REMOVE_CHAT_FROM_AGENT, async (chatId) => {
      await store.dispatch(removeUnAnsweredConversation(chatId));
      await store.dispatch(removeAnsweredConversation(chatId));
      await store.dispatch(checkRemoveConversationInAttendance(chatId));
      removeChatSavedById(chatId);
    });
  }, [socketChatTS]);

  useEffect(() => {
    socketChatTS.on(EVENTS_EMIT.REMOVE_CHAT_ON_HOLD, async (chatId) => {
      await store.dispatch(removeUnAnsweredConversation(chatId));
    });
  }, [socketChatTS]);

  useEffect(() => {
    socketChatTS.on(EVENTS_EMIT.ADD_CHAT_IN_AGENT, async (chat) => {
      await store.dispatch(addAnsweredConversation(chat));
    });
  }, [socketChatTS]);

  useEffect(() => {
    socketChatTS.on(
      EVENTS_EMIT.CHAT_TRANSFER_BOT_TO_ATTENDANCE,
      async (data) => {
        await store.dispatch(addAnsweredConversation(data.conversa));
      }
    );
  }, [socketChatTS]);

  useEffect(() => {
    socketChatTS.on(EVENTS_EMIT.CUSTOMER_SENDING_MESSAGE, async (data) => {
      data.mensagem = { hora_da_mensagem: new Date(), ...data.mensagem };

      await store.dispatch(
        addMessageConversationInAttendance(data.mensagem, data.idDaConversa)
      );
      await store.dispatch(
        addMessageAnsweredConversation(
          data.mensagem,
          data.idDaConversa,
          data.novas_mensagens
        )
      );

      await store.dispatch(
        addMessageUnansweredConversation(
          data.mensagem,
          data.idDaConversa,
          data.novas_mensagens
        )
      );
    });
  }, [socketChatTS]);

  useEffect(() => {
    socketChatTS.on(EVENTS_EMIT.CHANGE_MESSAGE_WHATSAPP_ID, (payload) => {
      store.dispatch(updateWhatsappMessageIdConversationInAttendance(payload));
    });
  }, [socketChatTS]);

  useEffect(() => {
    socketChatTS.on(EVENTS_EMIT.EVENT_OF_MESSAGE, async (eventMessage) => {
      await store.dispatch(
        updateStatusMessageConversationInAttendance(eventMessage)
      );
    });
  }, [socketChatTS]);

  useEffect(() => {
    socketChatTS.on(EVENTS_EMIT.DELETE_MESSAGE_FROM_CHAT, async (data) => {
      await store.dispatch(deleteMessageConversationInAttendance(data));
    });
  }, [socketChatTS]);

  useEffect(() => {
    socketChatTS.on(EVENTS_EMIT.AMD_SENDING_WHISPER, async (data) => {
      data.mensagem = { hora_da_mensagem: new Date(), ...data.mensagem };
      await store.dispatch(
        addMessageConversationInAttendance(data.mensagem, data.idDaConversa)
      );
      await store.dispatch(
        addMessageAnsweredConversation(
          data.mensagem,
          data.idDaConversa,
          data.novas_mensagens
        )
      );
    });
  }, [socketChatTS]);

  useEffect(() => {
    socketChatTS.on(EVENTS_EMIT.CHAT_TRANSFERRED, (data) => {
      let idDaConversa = data.id ?? data._id;
      store.dispatch(removeAnsweredConversation(data));
      store.dispatch(checkRemoveConversationInAttendance(idDaConversa));
    });
  }, [socketChatTS]);

  useEffect(() => {
    socketChatTS.on(
      EVENTS_EMIT.UPDATE_CONFIG_SIGNAL_CONVERSATION,
      async (data) => {
        window.localStorage.setItem(
          'configSignalConversation',
          JSON.stringify(data)
        );
      }
    );
  }, [socketChatTS]);

  useEffect(() => {
    socketChatTS.on(
      EVENTS_EMIT.UPDATE_METRICS_OF_SERVICE_PANEL,
      async (data) => {
        store.dispatch(getDailyClosedChat(data));
      }
    );
  }, [socketChatTS]);

  const emitEventTransferChatToQueue = ({
    chatId,
    queueId,
    subject,
    observation,
    sector
  }) => {
    socketChatTS.emit(EVENTS_EMIT.TRANSFER_CHAT_TO_QUEUE, {
      chatId,
      queueId,
      subject,
      observation,
      sector,
      responsibleForTransferred: {
        name: localStorage.getItem('name'),
        login: localStorage.getItem('login')
      }
    });
  };

  const emitEventTransferMultipleChatsToQueue = ({
    chatIds,
    queueId,
    subject,
    observation,
    sector
  }) => {
    socketChatTS.emit(EVENTS_EMIT.TRANSFER_MULTIPLE_CHAT_TO_QUEUE, {
      chatIds,
      queueId,
      subject,
      observation,
      sector,
      responsibleForTransferred: {
        name: localStorage.getItem('name'),
        login: localStorage.getItem('login')
      }
    });
  };

  const emitEventFinishChat = ({ chatId, body }) => {
    socketChatTS.emit(EVENTS_EMIT.ATTENDANT_FINISH_CHAT, {
      id: chatId,
      body: {
        ...body,
        loginUserRequest: localStorage.getItem('login'),
        nameUserRequest: localStorage.getItem('name')
      }
    });
  };

  const emitEventFinishMultipleChats = ({ chatIds, body }) => {
    socketChatTS.emit(EVENTS_EMIT.FINISH_MULTIPLE_CONVERSATION, {
      chatIds,
      body: {
        ...body,
        loginUserRequest: localStorage.getItem('login'),
        nameUserRequest: localStorage.getItem('name')
      }
    });
  };

  const emitEventAnsweredChat = async ({ chatId, socketId }) => {
    socketChatTS.emit(EVENTS_EMIT.ANSWERED_CHAT, {
      atendente: {
        nome: localStorage.getItem('name'),
        login: localStorage.getItem('login'),
        id_socket: socketId
      },
      id: chatId
    });
  };

  return (
    <>
      <useSocketConversationChatTsContext.Provider
        value={{
          socketChatTS,
          emitEventTransferChatToQueue,
          emitEventTransferMultipleChatsToQueue,
          emitEventFinishMultipleChats,
          emitEventFinishChat,
          emitEventAnsweredChat
        }}
      >
        {children}
      </useSocketConversationChatTsContext.Provider>
    </>
  );
}

/**
 * @typedef {Function} useSocketConversationChatTsContext
 * @returns {{
 *  socketChatTS: SocketIOClient.Socket;
 * emitEventTransferChatToQueue: Function;
 * emitEventTransferMultipleChatsToQueue: Function;
 * emitEventFinishChat: Function;
 * emitEventFinishMultipleChats: Function;
 * emitEventAnsweredChat: Function;
 * }}
 */

export function useSocketConversationChatTs() {
  const context = useContext(useSocketConversationChatTsContext);
  return context;
}
